"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentCardActivity = void 0;
var Utilities_1 = require("../../Utilities");
var DocumentCardActivity_base_1 = require("./DocumentCardActivity.base");
var DocumentCardActivity_styles_1 = require("./DocumentCardActivity.styles");
exports.DocumentCardActivity = Utilities_1.styled(DocumentCardActivity_base_1.DocumentCardActivityBase, DocumentCardActivity_styles_1.getStyles, undefined, { scope: 'DocumentCardActivity' });
//# sourceMappingURL=DocumentCardActivity.js.map